<template>
    <div class="row border-bottom">
        <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
            <div class="navbar-header"><a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="#"><i
                    class="fa fa-bars"></i> </a>
                <form role="search" class="navbar-form-custom" method="post" action="search_results.html">
                    <div class="form-group">
                        <!--
                        <input type="text" placeholder="请输入您需要查找的内容 …" class="form-control" name="top-search" id="top-search">
                        -->
                    </div>
                </form>
            </div>
            <ul class="nav navbar-top-links navbar-right">
                <li class="dropdown">
                    <a class="dropdown-toggle count-info" data-toggle="dropdown" href="javascript:void ();" @click="menuShow()">
                        <i class="fa fa-tasks"></i> {{user.name}}
                    </a>
                    <ul class="dropdown-menu dropdown-alerts" :style="show" >
                        <li>
                            <a href="javascript:void(0);" v-on:click="updatePassword()">
                                <div>
                                    <i class="fa fa-key fa-fw"></i></i> 修改密码
                                </div>
                            </a>
                        </li>
                        <li>
                            <a href="javascript:void(0);" v-on:click="signOut()">
                                <div>
                                    <i class="fa fa-sign-out fa-fw"></i> 退出系统
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
        <div class="modalDetails" v-if="accountShow">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <font style="font-size:16px; float:left">密码修改</font>
                        <button type="button" class="close" data-dismiss="modal" @click="accountShow = false"><span
                                aria-hidden="true">&times;</span><span class="sr-only">关闭</span></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="putForm" class="form-horizontal m-t">

                            <div class="form-group">
                                <label class="col-sm-3 control-label"><font class="xing">* </font>原密码 ：</label>
                                <div class="col-sm-7">
                                    <input type="text" class="form-control" aria-required="true"
                                           v-model="account.oldpassword">
                                </div>
                                <!--<div class="field-error col-sm-2" v-if="$v.form.name.$dirty">-->
                                <!--<div class="error" v-if="!$v.form.name.required">必填项</div>-->
                                <!--</div>-->
                            </div>

                            <div class="form-group">
                                <label class="col-sm-3 control-label"><font class="xing">* </font> 新密码：</label>
                                <div class="col-sm-7">
                                    <input type="text" class="form-control" aria-required="true"
                                           v-model="account.newpassword">
                                </div>
                                <!--<div class="field-error col-sm-2" v-if="$v.form.mobile.$dirty">-->
                                <!--<div class="error" v-if="!$v.form.mobile.required">必填项</div>-->
                                <!--</div>-->
                            </div>

                            <div class="form-group">
                                <button class="btn btn-primary submBtn" type="submit">确认修改</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import meService from '@/services/me'

  import { changePassword } from '../../services/password'

  import notify from '@/utils/notify'

  export default {
    name: 'PageHeader',
    computed: {
      ...mapGetters([
        'user',
        'hasBoards',
        'personalBoards',
        'teamBoards'
      ])
    },
    data: function () {
      return {
        account: {},
        accountShow: false,
        show:{
          display: 'none'
        }
      }
    },
    mounted () {
      if (!this.user.authenticated) {
        // this.$store.dispatch('getMyData')
        this.$router.push({
          name: 'login'
        })
      }
      console.log(this.user);
    },
    methods: {
      menuShow(){
        if (this.show.display == 'block') {
          this.show.display = 'none';
        }else{
          this.show.display = 'block';
        }
      },
      putForm () {
        this.show.display = 'none';
        this.$confirm('确定修改密码吗？, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log(this.account)
          changePassword(this.account).then(res => {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
            meService.signOut(this.user.token).then(() => {
              this.$store.dispatch('logout')
              this.$router.push({
                name: 'login'
              })
            }).catch(error => {
              notify.error(error.message)
            })
          }).catch(error => {})
        })
      },
      updatePassword () {
        this.show.display = 'none';
        this.accountShow = true;
      },
      signOut () {
        this.show.display = 'none';
        meService.signOut(this.user.token).then(() => {
          this.$store.dispatch('logout')
          this.$router.push({
            name: 'login'
          })
        }).catch(error => {
          notify.error(error.message)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .submBtn{
        margin: 20px auto 0;
        display: block;
    }
    .form-group{
        margin-bottom: 10px;
    }
    .modalDetails{
        position: fixed;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        overflow: hidden;
        -webkit-overflow-scrolling: touch;
        outline: 0;
        top:50%;
        transform:translateY(-50%);
    }
    .navbar-top-links .dropdown-messages, .navbar-top-links .dropdown-tasks, .navbar-top-links .dropdown-alerts {
        width: 150px;
        min-width: 0;
    }
</style>
